import type * as React from "react";

import { Input } from "./input";
import { useNumericInput } from "./use-numeric-input";

interface IIntegerInputProps
  extends Omit<
    React.ComponentPropsWithoutRef<typeof Input>,
    "onChange" | "value" | "onBlur"
  > {
  onChange?: (value: number | null) => void;
  value?: number | null;
  onBlur?: (
    value: number | null,
    event: React.FocusEvent<HTMLInputElement>,
  ) => void;
}

const IntegerInput = ({
  onChange,
  value,
  onBlur,
  onFocus,
  ref,
  ...props
}: IIntegerInputProps & {
  ref?: React.Ref<React.ElementRef<typeof Input>>;
}) => {
  const { displayValue, handleFocus, handleChange, handleBlur } =
    useNumericInput({
      value,
      onChange,
      onBlur,
      onFocus,
      type: "integer",
    });

  return (
    <Input
      ref={ref}
      value={displayValue}
      onFocus={handleFocus}
      onChange={handleChange}
      onBlur={handleBlur}
      inputMode="numeric"
      {...props}
    />
  );
};

IntegerInput.displayName = "IntegerInput";

export type { IIntegerInputProps };
export { IntegerInput };
